module.exports = __webpack_public_path__ + "static/img/alipayHK.883a5e62.png";